// Components
import { Checkbox, type CheckboxProps } from "@mui/material";

export type DomainBooleanInputProps = CheckboxProps & {
    value: boolean;
    onChange?: (value: boolean) => void;
};

export function DomainBooleanInput({
    value,
    onChange,
    ...props
}: DomainBooleanInputProps): JSX.Element {
    return (
        <Checkbox
            checked={value}
            onChange={(event) => onChange && onChange(Boolean(event.target.checked))}
            {...props}
        />
    );
}
